const AUTH_EVENT = 'cmms-auth-changed'

let authSnapshotCache = {
  isLoggedIn: false,
  userName: '',
  userRole: '',
}

const notifyAuthChange = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_EVENT))
  }
}

export const isUserLoggedIn = () => {
  const authorization = sessionStorage.getItem('Authorization')
  return !!(authorization && authorization.length > 1)
}

export const getAuth = () => sessionStorage.getItem('Authorization') || ''

export const setAuthorization = (auth) => {
  sessionStorage.setItem('Authorization', auth)
  notifyAuthChange()
}

export const getLoggedUserName = () => sessionStorage.getItem('userName') || ''

export const setLoggedUserName = (userName) => {
  sessionStorage.setItem('userName', userName)
  notifyAuthChange()
}

export const getLoggedUserRole = () => sessionStorage.getItem('userRole') || ''

const normalizeRole = (role) => {
  if (!role) return ''
  const normalized = String(role).trim().toLowerCase()
  if (normalized === '0') return 'admin'
  if (normalized === '1') return 'manager'
  if (normalized === '2') return 'operador'
  return normalized
}

export const hasAnyRole = (...roles) => {
  const currentRole = normalizeRole(getLoggedUserRole())
  return roles.map(normalizeRole).includes(currentRole)
}

export const isAdmin = () => hasAnyRole('admin')

export const setLoggedUserRole = (userRole) => {
  sessionStorage.setItem('userRole', userRole)
  notifyAuthChange()
}

export const logout = () => {
  sessionStorage.removeItem('userRole')
  sessionStorage.removeItem('userName')
  sessionStorage.removeItem('Authorization')
  notifyAuthChange()
}

export const subscribeAuth = (callback) => {
  const listener = () => callback()
  window.addEventListener(AUTH_EVENT, listener)
  window.addEventListener('storage', listener)
  return () => {
    window.removeEventListener(AUTH_EVENT, listener)
    window.removeEventListener('storage', listener)
  }
}

export const getAuthSnapshot = () => {
  const nextSnapshot = {
    isLoggedIn: isUserLoggedIn(),
    userName: getLoggedUserName(),
    userRole: getLoggedUserRole(),
  }

  if (
    authSnapshotCache.isLoggedIn !== nextSnapshot.isLoggedIn ||
    authSnapshotCache.userName !== nextSnapshot.userName ||
    authSnapshotCache.userRole !== nextSnapshot.userRole
  ) {
    authSnapshotCache = nextSnapshot
  }

  return authSnapshotCache
}
